import { cn } from '@bw/core';
import { Block } from '../../factories/types';
import { schemeToClass } from '../../utils/colorMap';
import { defined } from '../../utils/defined';
import { RichText } from '../../utils/rich-text/RichText';
import styles from './TextMarquee.module.scss';
import { TextMarqueeSlider } from './TextMarqueeSlider';

export const TextMarquee: Block<'textMarquee'> = ({ 
  data: {
    fields: {
      colorScheme,
      items
    }
  }, 
  fieldId 
}) =>
  items?.length &&
  <section className={cn(styles.textMarquee, schemeToClass(colorScheme))} {...fieldId('.')}>
    <div className="container container--max">
      <div className={styles.slider} data-aos="fade-up">
        <div className={styles.sliderTrack}>
          <TextMarqueeSlider>
            {defined(items).map((item, idx) => (
              <div key={idx}>
                <RichText document={item.fields.text} />
              </div>
            ))}
          </TextMarqueeSlider>
        </div>
      </div>
    </div>
  </section>
